// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GyYng::part(side-modal){width:440px !important}.nPKUG ::part(pill-wrapper){max-width:350px}`, "",{"version":3,"sources":["webpack://./src/components/visibilityPreferences/VisibilityPreferences.module.scss"],"names":[],"mappings":"AAAA,yBACE,sBAAA,CAIA,4BACE,eAAA","sourcesContent":[".preferencesModal::part(side-modal) {\n  width: 440px !important;\n}\n\n.dropdownSome {\n  ::part(pill-wrapper) {\n    max-width: 350px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preferencesModal": `GyYng`,
	"dropdownSome": `nPKUG`
};
export default ___CSS_LOADER_EXPORT___;
